export default "https://legacy.eskolare-development.com/images/ovni.png";